import { _js } from '@ifixit/utils/localize';
import { TiptapButton } from '../TiptapButton';
import { FaIcon } from '@ifixit/ui/components/icon';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const IndentButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isDisabled: !editor.can().sinkListItem('listItem'),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().sinkListItem('listItem').run()}
         isDisabled={state.isDisabled}
         icon={<FaIcon name="indent" />}
         title={_js('Increase indent')}
         overrideShortcut={'tab'}
      />
   );
};
